// console.log('mobile - ui.js');

//특수문자 제거
const gfn_regDelete = function (str) {
    let reg = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi; //특수문자확인
    if (reg.test(str)) {
        //특수문자가 있을경우 제거
        return str.replace(reg, '');
    } else {
        //특수문자가 없을경우 그냥 리턴
        return str;
    }
};

//Global jQuery Selector
const $window = $(window);
const $document = $(document);
const $scrollBody = $('html,body');
const $body = $('body');
const $appLayered = $('.app-layered');
const $cookieInformation = $('.cookie-information');
const $appHeader = $('.app-header');
const $app = $('.app');

//Global Variables
let gvr_winW = $window.outerWidth();
let gvr_winH = $window.outerHeight();
let gvr_docH = $document.outerHeight();
let gvr_st = $window.scrollTop();
let gvr_fixedSt = 0; //when body is fixed, move screen position
let layeredHistory = [];
let gvr_scrollDown = true;

//vh 문제점(변수화)
const gfn_vhFix = function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
};
gfn_vhFix();

//Fix BODY
const gfn_body = {
    fix: function () {
        gvr_fixedSt = gvr_st;
        $body.addClass('is-fixed').css({
            top: -1 * gvr_st + 'px',
        });
    },
    loose: function () {
        //console.log(gvr_fixedSt);
        $body.removeClass('is-fixed').removeAttr('style');
        //$scrollBody.stop().animate({ scrollTop: gvr_fixedSt }, 1);
        setTimeout(function () {
            $scrollBody.scrollTop(gvr_fixedSt);
        }, 0);
    },
};

//Side Menu (.sitemap)
const $sitemap = $('.app-header .sitemap');
const gfn_sitemap = {
    init: function () {
        $sitemap.find('li').each(function () {
            let $btn = $(this).children('a');
            if ($(this).children('ul').length > 0) {
                $btn.addClass('depth-view');
                if ($(this).children('ul').is(':hidden')) {
                    $btn.removeClass('is-show').addClass('is-hide');
                } else if (!$(this).children('ul').is(':hidden')) {
                    $btn.removeClass('is-hide').addClass('is-show');
                }
            }
        });
        $sitemap.on('animationend', function () {
            $(this).removeClass('is-deactive');
        });
    },
    show: function () {
        $appHeader.addClass('is-active');
        $sitemap.addClass('is-active');
        $('.lx_btn-sitemap').addClass('is-active');
        // window.history.pushState({}, document.title, '#sideMenuOpen');
        gfn_body.fix();
    },
    hide: function () {
        $sitemap.removeClass('is-active').addClass('is-deactive');

        $('.lx_btn-sitemap').removeClass('is-active');
        $appHeader.removeClass('is-active');
        gfn_body.loose();
        // window.history.replaceState(
        //     {},
        //     document.title,
        //     window.location.href.split('#')[0],
        // );
    },
};
gfn_sitemap.init();

const gfn_footer = {
    in: function (st) {
        if ($('.app-footer').length) {
            if (st + gvr_winH >= $('.app-footer').offset().top + 52) {
                $('.app-footer__quick').addClass('is-float');
            } else {
                $('.app-footer__quick').removeClass('is-float');
            }
        }
    },
};

let appHeaderStatus = $appHeader.data('status');
const gfn_appHeader = {
    status: function (status) {
        switch (status) {
            case 'transparent':
                if (appHeaderStatus == 'transparent')
                    $appHeader.attr('data-status', 'transparent');
                break;
            case 'active':
                if (appHeaderStatus == 'transparent')
                    $appHeader.removeClass('is-transparent');
                $appHeader.addClass('is-active');
                break;
            default:
                if (appHeaderStatus == 'transparent' && gvr_st < gvr_winH / 2)
                    $appHeader.addClass('is-transparent');
                $appHeader.removeClass('is-active');
                break;
        }
    },
    scroll: function (st) {
        if (
            appHeaderStatus == 'transparent' &&
            !$appHeader.hasClass('is-active')
        ) {
            if (st >= gvr_winH / 2) {
                $appHeader.removeClass('is-transparent');
            } else {
                $appHeader.addClass('is-transparent');
            }
        }
    },
};

const btnTop = {
    activation: function (st) {
        if (st >= gvr_winH * 0.5) {
            $('.lx_btn-top').show();
        } else {
            $('.lx_btn-top').hide();
        }
    },
};

//Common Layered (Notice, )
const gfn_layered = {
    //레이어열기
    open: function (layeredName) {
        // console.log(`excute gfn_layered.open(${layeredName})`);
        // console.log('오픈전 : ' + layeredHistory);

        //markup에 레이어가 없을때
        if (!$(`.js_layered[data-layered-name=${layeredName}]`).length) {
            console.log(`"${layeredName}"라는 이름의 팝업은 없습니다.`);
            return false;
        }

        //layered 안에 내용이 없을때
        if (
            $(`.js_layered[data-layered-name=${layeredName}]`).children()
                .length <= 1
        ) {
            console.log(
                `"${layeredName}"에는 데이터가 존재하지 않아 레이어를 닫습니다.`,
            );
            gfn_layered.close(layeredName);
            window.history.pushState(
                {},
                document.title,
                window.location.href.split('#')[0],
            );
            return false;
        }

        //중복 방지
        let urlParams = new URLSearchParams(location.search);
        let activedLayeredName = urlParams.get('layered');

        if (
            $(`.js_layered[data-layered-name=${activedLayeredName}]`).hasClass(
                'is-active',
            ) &&
            activedLayeredName == layeredName
        ) {
            console.log(
                `"${layeredName}"라는 이름의 팝업은 이미 오픈 되어있습니다.`,
            );
            return false;
        }

        //여기서부터 동작
        //주소 변경
        window.history.pushState({}, document.title, '#' + layeredName);

        //layered 히스토리에 추가
        //console.log((layeredHistory[layeredHistory.length - 1], layeredName));
        if (layeredHistory[layeredHistory.length - 1] != layeredName) {
            layeredHistory.push(layeredName);
        }

        $('.js_layered')
            .each(function (i) {
                let $this = $(this);
                if ($this.data('layered-name') == layeredName) {
                    $this.addClass('is-active');

                    //공지형이고, 1개 이상일때
                    if (
                        layeredName == 'notice' &&
                        $(`.js_layered[data-layered-name=${layeredName}]`).find(
                            '.swiper-slide',
                        ).length > 1
                    ) {
                        gfn_noticeLayered.init();
                    }

                    if ($this.data('init-call'))
                        window[$this.data('init-call')](
                            $this.data('init-param'),
                        );
                } else {
                    //layer 이름이 같지 않으면 닫기
                    $(this).removeClass('is-active');
                }
            })
            .promise()
            .done(function () {
                gfn_layered.wrap();
                //console.log('오픈후 : ' + layeredHistory);
            });
    },
    historyBack: function () {
        //console.log(layeredHistory);
        //이전 주소에 레이어 주소가 있는 경우
        if (layeredHistory.length > 1) {
            layeredHistory.pop();
            let layeredName = layeredHistory[layeredHistory.length - 1];
            gfn_layered.open(layeredName);
        }
        //이전 주소에 레이어 주소가 없는 경우
        else {
            //console.log('이전 주소에 레이어 주소가 없는 경우');
            window.history.replaceState(
                {},
                document.title,
                window.location.href.split('#')[0],
            );
            gfn_layered.close(layeredHistory[0]);
            layeredHistory.length = 0;
        }
    },
    //레이이닫기
    close: function (layeredName) {
        //지정된 레이어이름이 있는 경우
        if (layeredName) {
            $('.js_layered')
                .each(function (i) {
                    if ($(this).data('layered-name') == layeredName) {
                        $(this).removeClass('is-active');

                        let $ytArea = $(this).find('.youtube-area');
                        if ($ytArea.length) $ytArea.empty();
                    }
                })
                .promise()
                .done(function () {
                    gfn_layered.wrap();
                });
        }
        //지정된 레이어이름이 없는 경우 전체 닫기
        else {
            let $ytArea = $('.app-layered').find('.is-active .youtube-area');
            if ($ytArea.length) $ytArea.empty();
            $('.app-layered')
                .removeClass('is-active')
                .find('.is-active')
                .removeClass('is-active');
            gfn_layered.wrap();
        }
    },
    wrap: function () {
        //열려있는 레이어가 있는지 체크
        if ($('.js_layered.is-active').length > 0) {
            gfn_body.fix();
            $appLayered.addClass('is-active').scrollTop(0);
        } else {
            gfn_body.loose();
            $appLayered.removeClass('is-active');
        }
    },
    //url에 레이어 값이 있을때 열기
    urlCheck: function () {
        let activedLayeredName = gfn_regDelete(location.hash);

        if (activedLayeredName != '') {
            if (activedLayeredName != layeredHistory[layeredHistory.length - 1])
                gfn_layered.open(activedLayeredName);
        } else {
            gfn_layered.close();
        }
    },
};

//Accordion
const gfn_accordion = {
    init: function () {
        if ($('.lx_accordion').length) {
            $('.lx_accordion')
                .find('.is-active')
                .children('div:last-child')
                .slideDown();
        }
    },
    select: function ($this) {
        let $list = $this.parent('li');
        if (!$list.hasClass('is-active')) {
            $list
                .siblings('li')
                .removeClass('is-active')
                .children('div:last-child')
                .slideUp(200);
            $list
                .addClass('is-active')
                .children('div:last-child')
                .slideDown(200, function () {
                    let top = $list.offset().top;
                    $scrollBody.stop().animate({ scrollTop: top - 60 }, 100);
                });
        } else {
            $list
                .removeClass('is-active')
                .children('div:last-child')
                .slideUp(200);
        }
    },
};

//공지형 레이어
let noticeSwiper;
const gfn_noticeLayered = {
    init: function (_loop) {
        if (noticeSwiper != undefined) noticeSwiper.destroy(true, true);
        noticeSwiper = new Swiper('.layered--notice__swiper', {
            loop: _loop,
            pagination: {
                el: '.layered--notice__pagination',
                clickable: true,
            },
            on: {
                init: function () {
                    console.log('공지형 레이어팝업 swiper init');
                    gfn_noticeLayered.navigation();
                },
            },
        });
    },
    navigation: function () {
        $('.layered--notice__navigation')
            .empty()
            .append(
                '<button class="btn-prev" type="button"><span>Previous Slide</span></button><button class="btn-next" type="button"><span>Next Slide</span></button>',
            );
        $('.layered--notice__navigation > button').click(function () {
            if ($(this).hasClass('btn-prev')) {
                noticeSwiper.slidePrev();
            } else if ($(this).hasClass('btn-next')) {
                noticeSwiper.slideNext();
            }
        });
    },
};

//INPUT Form
const gfn_lxForm = {
    init: function () {
        $('.lx_input, .lx_dropdown, .lx_textarea').addClass('lx_form');
        $('.lx_textarea').has('textarea[readonly]').addClass('is-readonly');
    },
    error: function (id, msg) {
        //console.log(id, msg);
        var $selector = $('#' + id);
        $selector.parents('.lx_form').attr('data-status', 'error');
        if (!msg) {
            let $msg = $selector
                .focus()
                .parent('.lx_form-inner')
                .next('.error-msg');
            if (!$msg) {
                alert('Error 메시지가 없습니다!!!');
            } else {
                $msg.show();
            }
        } else {
            $selector
                .focus()
                .parent('.lx_form-inner')
                .next('.error-msg')
                .remove();
            $selector
                .parent('.lx_form-inner')
                .after(`<span class="error-msg">${msg}</span>`);
        }
    },
    noError: function (id) {
        var $selector = $('#' + id);
        $selector.parents('.lx_form').removeAttr('data-status');
    },
};

//TAB
let gfn_tabPosition = [];
let gfn_tabActive = [];
let tabPrev = 40;
const gfn_tab = {
    init: function () {
        let $tab = $('.lx_tab');
        if ($tab.length) {
            //init
            $tab.parent().unwrap('.lx_tab-wrap');
            $tab.unwrap('.lx_tab-fixed');
            $tab.wrap(
                '<div class="lx_tab-wrap"><div class="lx_tab-fixed"></div></div>',
            );

            if ($tab.data('type', 'sorting')) {
                $tab.closest('.lx_tab-wrap').addClass('sorting-tab');
            }

            $tab.each(function (i) {
                let idx = i;
                gfn_tabPosition[idx] = [];
                if ($(this).hasClass('size-xl'))
                    $(this).closest('.lx_tab-wrap').addClass('size-xl');
                $(this).attr('data-index', i);
                $(this)
                    .find('[role=tab]')
                    .each(function (j) {
                        //console.log(idx, j, $(this).offset().left);
                        gfn_tabPosition[idx][j] = parseInt(
                            $(this).offset().left,
                        );
                    });
                gfn_tabActive[idx] = $(this)
                    .find('[aria-selected=true]')
                    .index();
                let gap = !Number($tab.data('gap')) ? 0 : $tab.data('gap');
                let activeIdx = gfn_tabActive[idx];
                let activePosition = parseInt(
                    gfn_tabPosition[idx][activeIdx] - tabPrev - gap,
                );
                //console.log(gap);
                $(this).scrollLeft(activePosition);
            });
            gfn_tab.position(gvr_st);
        }
    },
    select: function ($btnSelected) {
        let idx = $btnSelected.index();
        let id = $btnSelected.attr('id');
        $btnSelected.siblings().attr('aria-selected', false);
        $btnSelected.attr('aria-selected', true);
        $btnSelected
            .parents('.lx_tab-wrap')
            .siblings('[role=tabpanel]')
            .attr('hidden', true);
        $btnSelected
            .parents('.lx_tab-wrap')
            .siblings('[aria-labelledby=' + id + ']')
            .removeAttr('hidden');

        let $tab = $btnSelected.parent('.lx_tab');
        let tabIdx = Number($btnSelected.parent('.lx_tab').attr('data-index'));
        let gap = !Number($tab.data('gap')) ? 0 : $tab.data('gap');
        let scrollPosition = Number(
            gfn_tabPosition[tabIdx][idx] - tabPrev - gap,
        );
        $tab.stop().animate({ scrollLeft: scrollPosition }, 100);
    },
    position: function (st) {
        let $tab = $('.lx_tab').not('.no-fixed');
        if ($tab.length) {
            let $tabWrap = $tab.closest('.lx_tab-wrap');
            let tabTop = $tabWrap.offset().top;
            let position = $app.hasClass('is-scrolldown') ? 0 : 60;
            if (st >= tabTop - position) {
                $tabWrap.addClass('is-fixed');
            } else {
                $tabWrap.removeClass('is-fixed');
            }
        }
    },
};

//화면의 다른 곳을 클릭시 deactivation
const gfn_deactivation = function (e, className, activeClass) {
    activeClass = activeClass || 'is-active';
    let $target = $(e.target);
    if (
        !$target.hasClass('.' + className) &&
        !$target.closest('.' + className).length
    ) {
        $('.' + className).removeClass(activeClass);
        $('.' + className)
            .find('.' + activeClass)
            .removeClass(activeClass);
    }
};

function ytEmbed(targetID) {
    (function () {
        id = $('.company-pr-movie')
            .find('.lx_tab-pannel')
            .not(':hidden')
            .find('button')
            .data('yt-id');

        $('#' + targetID).append(
            `<iframe src="https://www.youtube.com/embed/${id}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`,
        );
        //console.log(targetID, id);
    })();
}

//Target이 화면 안에 들어왔을때 cls 삽입 (gap은 차이)
/*
    gfn_screen.on(
        $('.global_network__overview p'),
        {
            gap: '10',
            class: 'is-test',
            etc: 'etc ',
        },
        function () {
            console.log(argument[0].etc); //= 'etc'
        },
    );
 */
const gfn_screen = {
    on: function ($target, options, cb) {
        options = options || {};

        let activeSelector = options.class || 'is-animated';
        let type = options.type || '';
        let gap = 0;

        if (typeof $target.data('gap') != 'number') {
            gap = parseInt(options.gap) || 0;
            //console.log($target.attr('class'), '1', gap, $target.data('gap'));
        } else {
            let dataGap = Number($target.data('gap')) || 0;
            gap = (gvr_winH * dataGap) / 100;
            //console.log($target.attr('class'), '2', gap, $target.data('gap'));
        }

        //console.log(gap);

        if ($target.length) {
            // console.log('gvr_st:' + gvr_st);
            // console.log('gvr_winH:' + gvr_winH);
            // console.log('$target.offset().top:' + $target.offset().top);
            // console.log('gap:' + gap);
            // console.log('$target.outerHeight():' + $target.outerHeight());
            let duration = $target.data('duration');
            if ($target.data('duration')) {
                if (
                    $target.hasClass('ani_effect01-list') ||
                    $target.hasClass('ani_fadein-list') ||
                    $target.hasClass('ani_scaleup-list')
                ) {
                    $target.children().css({
                        'animation-duration': duration + 's',
                    });
                    $target.children().each(function (i) {
                        $(this).css({ 'animation-delay': duration * i + 's' });
                    });
                } else {
                    $target.css({
                        'animation-duration': duration + 's',
                    });
                }
            }

            if (
                gvr_st + gvr_winH >=
                $target.offset().top + $target.outerHeight() + gap
            ) {
                if (!$target.hasClass(activeSelector)) {
                    $target.addClass(activeSelector);
                    if (cb) cb(options);
                }
            } else {
                if (options.type != 'no-return')
                    //단발성 동작 no-return
                    $target.removeClass(activeSelector);
            }
        }
    },
};

let lastScrollTop = 0;
const gfn_scrollDirection = function (st) {
    if (st > lastScrollTop) {
        $app.addClass('is-scrolldown');
        gvr_scrollDown = true;
        // console.log('down');
    } else if (st < lastScrollTop) {
        $app.removeClass('is-scrolldown');
        gvr_scrollDown = false;
        // console.log('up');
    }
    lastScrollTop = st <= 0 ? 0 : st;
};

let resizeEventName;
const gfn_resizeEnd = function (cb) {
    clearTimeout(resizeEventName);
    resizeEventName = setTimeout(function () {
        cb();
    }, 100);
};

//Bind
$(document)
    //다른곳 클릭시 비활성화
    .on('click', function (e) {
        gfn_deactivation(e, 'app-header_global');
        gfn_deactivation(e, 'lx_form');
    })
    //전체메뉴 열고 닫기
    .on('click', '.lx_btn-sitemap', function () {
        if (!$(this).hasClass('is-active')) {
            gfn_sitemap.show();
        } else {
            gfn_sitemap.hide();
        }
    })
    //전체메뉴 상세 열고 닫기
    .on('click', '.depth-view', function () {
        let $this = $(this);
        $this
            .parent('li')
            .addClass('is-active')
            .siblings('li')
            .removeClass('is-active')
            .find('.depth-view')
            .removeClass('is-show')
            .addClass('is-hide')
            .next('ul')
            .slideUp();

        if ($this.hasClass('is-hide')) {
            $this.addClass('is-show').removeClass('is-hide');
            $this.next('ul').slideDown();
        } else if ($this.hasClass('is-show')) {
            $this.removeClass('is-show').addClass('is-hide');
            $this.next('ul').slideUp();
        }
    })
    //레이어팝업 닫기
    .on(
        'click',
        '.js_layered .btn-close-layered, .js_layered-close',
        function () {
            gfn_layered.historyBack();

            let $videoArea = $(this).closest('.layered').find('.video-area');
            if ($videoArea.length) $videoArea.find('video').get(0).pause();
        },
    )
    .on('click', '.js_close-all', function () {
        gfn_layered.close();
    })
    //레이어팝업 호출
    .on(
        'click',
        'button[data-open-layered], a[data-open-layered]',
        function (e) {
            e.preventDefault();
            let layeredName = $(this).data('open-layered');
            gfn_layered.open(layeredName);
        },
    )
    //is-active 토글키
    .on('click', '.js_toggle-class', function () {
        let cls =
            $(this).data('toggle') != undefined
                ? $(this).data('toggle')
                : 'is-active';
        $(this).toggleClass(cls);
    })
    //Quick Menu
    .on('click', '.lx_btn-quick', function () {
        $(this).toggleClass('is-active');
    })
    //TOP 버튼
    .on('click', '.lx_btn-top', function () {
        $scrollBody.scrollTop(0);
    })
    //다른 폼 포커스 제거
    .on(
        'focus',
        '.lx_form-inner > input, .lx_form-inner > button',
        function () {
            let $this = $(this).parents('.lx_form');
            $('.lx_form').not($this).removeClass('is-active');
        },
    )
    //TAB
    .on('click', '[role=tab]', function (e) {
        gfn_tab.select($(this));
    })
    //accordion
    .on(
        'click',
        '.lx_accordion > li > a, .lx_accordion > li > button',
        function (e) {
            gfn_accordion.select($(this));
        },
    );

//Init
const init = (() => {
    //Page가 로드 되면 레이어를 띄워야하는지 체크
    gfn_layered.urlCheck();

    //textarea
    gfn_lxForm.init();

    //TAB
    gfn_tab.init();

    //top btn lock
    gfn_footer.in(gvr_st);

    //header 투명
    gfn_appHeader.scroll(gvr_st);

    //Accordion
    gfn_accordion.init();
})();

$window
    .on('hashchange', function () {
        //레이어를 띄워야하는지 체크
        gfn_layered.urlCheck();
    })
    .on('scroll', function () {
        gvr_st = $(this).scrollTop();
        gvr_docH = $document.outerHeight();

        //스크롤 방향
        gfn_scrollDirection(gvr_st);

        //top btn lock
        gfn_footer.in(gvr_st);

        //header 투명
        gfn_appHeader.scroll(gvr_st);

        //탑버튼 활성화
        btnTop.activation(gvr_st);

        //탭 고정
        gfn_tab.position(gvr_st);
    })
    .on('resize', function () {
        gvr_st = $(this).scrollTop();
        gvr_winW = $(this).outerWidth();
        gvr_winH = $(this).outerHeight();
        gvr_docH = $document.outerHeight();
        gfn_vhFix();
    })
    .on('load', function () {
        //탑버튼 활성화
        btnTop.activation(gvr_st);

        var $selectedTab = $('[role=tab][aria-selected="true"]');
        if ($selectedTab.length) {
            gfn_tab.select($selectedTab);
        }
    });

//Page
$('.js_family-site select').on('change', function () {
    let url = $(this).val();
    window.open(url);
});

//Buniness 어코디언
$('.lx_accordion--business')
    .on('click', 'dt > button', function () {
        let $accordion = $(this).parents('.lx_accordion--business');
        let $dt = $(this).parent('dt');
        const areaLabel = $(this).attr('title');
        if (!$dt.hasClass('is-active')) {
            $dt.addClass('is-active').siblings().removeClass('is-active');
            $dt.next('dd').addClass('is-active');
            $accordion
                .siblings('.lx_accordion--business')
                .children()
                .removeClass('is-active');
            $scrollBody
                .stop()
                .delay(100)
                .animate(
                    {
                        scrollTop:
                            $accordion.offset().top - $appHeader.outerHeight(),
                    },
                    50,
                );
            $(this).attr('aria-label', areaLabel + ' Close');
        } else {
            $dt.removeClass('is-active').next('dd').removeClass('is-active');
            $(this).attr('aria-label', areaLabel + ' View Detail');
        }
    })
    .on('click', '.box--grey', function () {
        let $accordion = $(this).parents('.lx_accordion--business');
        if (!$accordion.find('dt').hasClass('is-active'))
            $accordion.find('dt button').click();
    });

//Pantos View Swiper
if ($('.pantos-view__swiper').length) {
    const pantosViewSwiper = new Swiper('.pantos-view__swiper', {
        loop: true,
        autoplay: {
            delay: 3000,
        },
        pagination: {
            el: '.pantos-view__swiper-pagination',
            clickable: true,
        },
        on: {
            init: function () {
                $('.pantos-view__swiper').on(
                    'click',
                    '.lx_btn-swiper-play',
                    function () {
                        pantosViewSwiper.autoplay.start();
                    },
                );
                $('.pantos-view__swiper').on(
                    'click',
                    '.lx_btn-swiper-stop',
                    function () {
                        pantosViewSwiper.autoplay.stop();
                    },
                );
            },
        },
    });
}
if ($('.pantos-view__detail-swiper').length) {
    const pantosViewSwiper02 = new Swiper('.pantos-view__detail-swiper', {
        loop: true,
        autoplay: {
            delay: 3000,
        },
        pagination: {
            el: '.pantos-view__detail-swiper-pagination',
            clickable: true,
        },
        on: {
            init: function () {
                $('.pantos-view__detail-swiper').on(
                    'click',
                    '.lx_btn-swiper-play',
                    function () {
                        pantosViewSwiper02.autoplay.start();
                    },
                );
                $('.pantos-view__detail-swiper').on(
                    'click',
                    '.lx_btn-swiper-stop',
                    function () {
                        pantosViewSwiper02.autoplay.stop();
                    },
                );
            },
        },
    });
}

//Animation
var gfn_commonAnimation = function () {
    // $('.ani_scaleup').each(function () {
    //     gfn_screen.on($(this));
    // });
    // $('.ani_scaleup-list').each(function () {
    //     gfn_screen.on($(this));
    // });
    $('.ani_fadein').each(function () {
        gfn_screen.on($(this));
    });
    $('.ani_fadein-list').each(function () {
        gfn_screen.on($(this));
    });
    $('.ani_effect01')
        .not('.box--grey')
        .each(function () {
            gfn_screen.on($(this), { gap: $(this).outerHeight() * -0.2 });
        });
    $('.ani_effect01-list').each(function () {
        gfn_screen.on($(this));
    });
    $('.box--grey').each(function () {
        gfn_screen.on($(this), { gap: $(this).outerHeight() * -0.6 });
    });
    $('.ani_effect02').each(function () {
        gfn_screen.on($(this));
    });
};
$window
    .on('load', function () {
        gfn_vhFix();
        gfn_commonAnimation();
    })
    .on('scroll', function () {
        gfn_commonAnimation();
    })
    .on('resize', function () {
        gfn_vhFix();
        gfn_commonAnimation();
    });
